<div id="library-timings" class="watermark">
  <div class="container-fluid px-lg-5 py-4">
    <div class="row">
      <div class="col-12 ">
        <h2 class="title mb-4">Library Timings</h2>
      </div>

      <div class="col-12">
        <p class="inner-lead ">
          <em>"Your time, your Library: Flexible hours for a better you!"</em>
        </p>

        <p class="inner-lead">
          <strong>Issue Desk:</strong> 9.00 A.M. to 2.30 P.M. (All working Days)
        </p>
        <p class="inner-lead">
          <strong>Reading Hours:</strong> 9.00 A.M. to 2.50 P.M. (All working Days)
        </p>
        <p class="inner-lead">
          <strong>Note:</strong> Users must leave the library 10 Minutes before closing time to ensure proper
          checking and locking of the library.
        </p>
      </div>
    </div>
  </div>
</div>
